import { LoadingButton } from '@mui/lab';
import { Box, Container, TextField, Typography } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import ReCAPTCHA from "react-google-recaptcha";
import axiosInstance from '../../../http-common';
import getErrorMessage from '../../../util';
import SnackbarWithMessage from '../../../common/components/Snackbars/SnackbarWithMessage';


const ForgotPasswordPage = () => {

  const [open_snackbar_with_message, set_open_snackbar_with_message] = useState({
    open: false,
    message: "",
    severity: "info"
  });

  const [sending_request, set_sending_request] = useState(false);

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      set_sending_request(true);
      const res = await axiosInstance.post(`/v1/user/forgot-password/`, {
        email,
      });
      const data = (await res).data;
      set_open_snackbar_with_message({
        open: true,
        message: data?.message || "Success!",
        severity: "success",
      });
    } catch (error) {
      set_open_snackbar_with_message({
        open: true,
        message: getErrorMessage(error),
        severity: "error",
      });
    }
    finally {
      set_sending_request(false);
    }
  };
  const [email, set_email] = useState("");

  const [captcha_verified, set_captcha_verified] = useState(false);
  function onChange(value) {
    // console.log("Captcha value:", value);
    if (value) set_captcha_verified(true);
    else set_captcha_verified(false);
  }

  useEffect(() => {
    document.title = "Ripik Optimus - Forgot Password";
  }, []);

  return (
    <Container maxWidth="sm">
      <SnackbarWithMessage {...open_snackbar_with_message} onClose={() => {
        set_open_snackbar_with_message({
          open: false,
          message: "",
          severity: "info"
        });
      }} />
      <div className="flex justify-center items-center">
        <img
          className="h-[10rem] mr-4"
          src="/ripikremovedbg.png"
          alt="ripik.ai"
        />
      </div>
      <Box sx={{
        marginTop: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}>
        <Typography component="h1" variant="h5">
          Enter your email to reset the password.
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{
          display: "flex",
          flexDirection: "column",
          gap: "20px",
          width: "300px",
          mt: 1
        }}>
          <TextField
            label="Email/Username"
            variant="outlined"
            autoComplete="email"
            fullWidth
            required
            onChange={(e) => {
              const text = e.target.value;
              set_email(text);
            }} />
          <ReCAPTCHA
            sitekey="6LcW7CgoAAAAAHcqrGsR4j--ynSaQs8rrpE6xeb2" onChange={onChange}
          />
          <Typography variant="body2" align="center" mt={2}>
            We will send you an email that will allow you to reset your password.
          </Typography>

          <LoadingButton disabled={!captcha_verified || !email || email?.length === 0} loading={sending_request} variant="contained" type="submit" color="primary" fullWidth sx={{ color: "white" }}>
            Submit
          </LoadingButton>
        </Box>
      </Box>
    </Container>
  );
};

export default ForgotPasswordPage;